import { render, staticRenderFns } from "./NavigationNoteItem.vue?vue&type=template&id=54925545&"
import script from "./NavigationNoteItem.vue?vue&type=script&lang=js&"
export * from "./NavigationNoteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports